import { useAppSelector } from "@/stores/hooks";
import type { RegionCode } from "@penn/web-common";
import {
  readGuestRegionCookie,
  resolveEffectiveRegion,
} from "@/utils/guest-region";

export function useRegion(): RegionCode {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const selected = useAppSelector((state) => state.auth.selectedRegion);
  const userCode = useAppSelector((state) => state.auth.user?.region?.code);
  return resolveEffectiveRegion({
    isAuthenticated,
    selectedRegion: selected,
    userRegion: userCode,
    guestRegion: readGuestRegionCookie(),
  });
}
